import { Component, Input } from '@angular/core';
import { Negociacao } from 'src/app/aplicacao/models/negociacao.model';

@Component({
  selector: 'app-detalhes-negociacao',
  templateUrl: './detalhes-negociacao.component.html',
  styleUrls: ['./detalhes-negociacao.component.scss']
})
export class DetalhesNegociacaoComponent {
  @Input() negociacao: Negociacao;
}
